import classNames from "classnames";

export interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export const Container = ({ className, children }: ContainerProps) => (
  <div
    className={classNames(
      "flex w-full max-w-[45rem] flex-col items-center",
      className,
    )}
  >
    {children}
  </div>
);
